import {
	CLEAR_DOC_SUBTYPE_MANAGEMENT_STATE,
	GET_ALL_DOC_SUBTYPES,
	GET_ALL_DOC_SUBTYPES_SUCCESS,
	GET_ALL_DOC_SUBTYPES_ERROR,
	GET_DOC_SUBTYPE_BY_ID,
	GET_DOC_SUBTYPE_BY_ID_SUCCESS,
	GET_DOC_SUBTYPE_BY_ID_ERROR,
	CREATE_DOC_SUBTYPE,
	CREATE_DOC_SUBTYPE_SUCCESS,
	CREATE_DOC_SUBTYPE_ERROR,
	UPDATE_DOC_SUBTYPE,
	UPDATE_DOC_SUBTYPE_SUCCESS,
	UPDATE_DOC_SUBTYPE_ERROR,
	DELETE_DOC_SUBTYPE,
	DELETE_DOC_SUBTYPE_SUCCESS,
	DELETE_DOC_SUBTYPE_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const DOC_SUBTYPE_URL = '/docSubtype';

const defaultState = () => ({
	docSubtypesList: [],
	isLoadingDocSubtypes: '',
});

const state = defaultState();

const getters = {
	docSubtypesList: (state) => state.docSubtypesList,
	isLoadingDocSubtypes: (state) => state.isLoadingDocSubtypes === 'loading',
};

const mutations = {
	[CLEAR_DOC_SUBTYPE_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_DOC_SUBTYPES]: (state) => {
		state.isLoadingDocSubtypes = 'loading';
	},
	[GET_ALL_DOC_SUBTYPES_SUCCESS]: (state, data) => {
		state.docSubtypesList = data;
		state.isLoadingDocSubtypes = 'success';
	},
	[GET_ALL_DOC_SUBTYPES_ERROR]: (state) => {
		state.isLoadingDocSubtypes = 'error';
	},
	[GET_DOC_SUBTYPE_BY_ID]: (state) => {
		state.isLoadingDocSubtypes = 'loading';
	},
	[GET_DOC_SUBTYPE_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingDocSubtypes = 'success';
	},
	[GET_DOC_SUBTYPE_BY_ID_ERROR]: (state) => {
		state.isLoadingDocSubtypes = 'error';
	},
	[CREATE_DOC_SUBTYPE]: (state) => {
		state.isLoadingDocSubtypes = 'loading';
	},
	[CREATE_DOC_SUBTYPE_SUCCESS]: (state) => {
		state.isLoadingDocSubtypes = 'success';
	},
	[CREATE_DOC_SUBTYPE_ERROR]: (state) => {
		state.isLoadingDocSubtypes = 'error';
	},
	[UPDATE_DOC_SUBTYPE]: (state) => {
		state.isLoadingDocSubtypes = 'loading';
	},
	[UPDATE_DOC_SUBTYPE_SUCCESS]: (state, data) => {
		state.isLoadingDocSubtypes = 'success';
	},
	[UPDATE_DOC_SUBTYPE_ERROR]: (state) => {
		state.isLoadingDocSubtypes = 'error';
	},
	[DELETE_DOC_SUBTYPE]: (state) => {
		state.isLoadingDocSubtypes = 'loading';
	},
	[DELETE_DOC_SUBTYPE_SUCCESS]: (state, data) => {
		state.isLoadingDocSubtypes = 'success';
	},
	[DELETE_DOC_SUBTYPE_ERROR]: (state) => {
		state.isLoadingDocSubtypes = 'error';
	},
};

const actions = {
	[GET_ALL_DOC_SUBTYPES]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_DOC_SUBTYPES);
			localStorage.setItem(`lastReqAdm`, 'docSubtypeManagement/GET_ALL_DOC_SUBTYPES');

			http({
				method: 'GET',
				url: `${DOC_SUBTYPE_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_DOC_SUBTYPES_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_DOC_SUBTYPES_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_DOC_SUBTYPE_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_DOC_SUBTYPE_BY_ID);

			http({
				method: 'GET',
				url: `${DOC_SUBTYPE_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_DOC_SUBTYPE_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_DOC_SUBTYPE_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_DOC_SUBTYPE]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_DOC_SUBTYPE);

			http({
				method: 'POST',
				url: `${DOC_SUBTYPE_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Subtipo de Documentos criado com sucesso.');
					commit(CREATE_DOC_SUBTYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_DOC_SUBTYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_DOC_SUBTYPE]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_DOC_SUBTYPE);

			http({
				method: 'PATCH',
				url: `${DOC_SUBTYPE_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Subtipo de Documentos editado com sucesso.');
					commit(UPDATE_DOC_SUBTYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_DOC_SUBTYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_DOC_SUBTYPE]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_DOC_SUBTYPE);

			http({
				method: 'DELETE',
				url: `${DOC_SUBTYPE_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Subtipo de Documentos excluído com sucesso.');
					commit(DELETE_DOC_SUBTYPE_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_DOC_SUBTYPE_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
